/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import IEtapas from 'Infotrack@Modelos/smartStock/etapas/entidades/etapas';
import IFlujos from 'Infotrack@Modelos/smartStock/flujos/entidades/flujos';
import IFlujosEtapas from 'Infotrack@Modelos/smartStock/flujosEtapas/entidades/flujosEtapas';
import IFlujosEtapasCompuesta from 'Infotrack@Modelos/smartStock/flujosEtapas/entidades/flujosEtapasCompuesta';
import React from 'react';

/* Vista */

export interface IInputsFlujosEtapas {
    EmpresaId: string;
    Entrada: boolean;
    Estado: boolean;
    EtapaActual: IEtapas | null;
    EtapaSiguiente: IEtapas | null;
    Flujo: IFlujos | null;
    Salida: boolean;
}

export interface ITablaFlujosEtapasVistaProps {
    flujosEtapass: IFlujosEtapasCompuesta[];
    confirmarEliminacion: (flujosEtapas: IFlujosEtapasCompuesta) => void;
    consultarFlujosEtapas: () => void;
    manejarFormulario: (tipoFormulario: TipoFormulario, entidadFlujosEtapas?: IFlujosEtapasCompuesta) => void;
}

export interface IFormularioFlujosEtapasVistaProps {
    accionCrearEditar: () => void;
    alCambiarValor: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
    alCambiarValorAutoComplete: (
        nuevoValor: IInputsFlujosEtapas[keyof IInputsFlujosEtapas],
        nombreValor: string
    ) => void;
    cerrarFormulario: () => void;
    estadoFormulario: boolean;
    entidadesFlujosEtapas: {
        flujoss: IFlujos[];
        etapass: IEtapas[];
    };
    esMovil: boolean;
    flujosEtapas: IInputsFlujosEtapas;
    tipoFormulario: TipoFormulario;
}

/* Redux y reductor */

export interface IEstadoFlujosEtapas {
    estadoFormulario: boolean;
    entidadFlujosEtapas: IFlujosEtapas | null;
    recargarTabla: boolean;
    tipoFormulario: TipoFormulario;
}

export interface IEstadoAPropiedades {
    EmpresaId: string;
}

export enum acciones {
    CAMBIAR_ESTADO_FORMULARIO = 'CAMBIAR_ESTADO_FORMULARIO',
    RECARGAR_TABLA = 'RECARGAR_TABLA',
}
